/*! playlist-events.js */

const PlaylistEvents = {
    ALL_ITEMS_PLAYED: "ALL_ITEMS_PLAYED",
    ITEM_LOAD: "ITEM_LOAD",
    ITEM_PRELOAD: "ITEM_PRELOAD",
    ITEM_UNLOAD: "ITEM_UNLOAD",
    RESIZE: "resize",
    SLIDE_CLICK: "SLIDE_CLICK",
    STARTED: "STARTED",
    TRANSITION_CANCEL: "TRANSITION_CANCEL",
    TRANSITION_END: "TRANSITION_END",
    TRANSITION_SKIP: "TRANSITION_SKIP",
    RESUME: "RESUME"
};

export default PlaylistEvents;
